import { useNavigate } from "react-router-dom";
import { PageHeader } from "@/components/layout/PageHeader";
import { StatusPill } from "@/components/shared/StatusPill";
import { PriorityDot } from "@/components/shared/PriorityDot";
import { Loading } from "@/components/shared/Loading";
import { useJobs } from "@/api/hooks";
import { money } from "@/lib/format";
import { BusinessStage } from "@/components/shared/BusinessStage";

export default function OpsJobs() {
  const navigate = useNavigate();
  const { data: jobs } = useJobs();
  if (!jobs) return <Loading />;

  return (
    <>
      <PageHeader title="Jobs" subtitle={`${jobs.length} active jobs in execution`} />
      <div className="flex-1 overflow-y-auto p-6">
        <div className="rounded-xl border border-slate-200 bg-white overflow-hidden">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-slate-200 bg-slate-50 text-[11px] uppercase tracking-wider text-slate-400">
                <th className="text-left font-semibold px-4 py-2.5 w-8"></th>
                <th className="text-left font-semibold px-4 py-2.5">Job</th>
                <th className="text-left font-semibold px-4 py-2.5">Mode / Lane</th>
                <th className="text-left font-semibold px-4 py-2.5">Current stage / last status</th>
                <th className="text-left font-semibold px-4 py-2.5">Credit</th>
                <th className="text-right font-semibold px-4 py-2.5">Est. revenue</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {jobs.map((j) => (
                <tr key={j.id} data-testid={`job-row-${j.id}`} onClick={() => navigate(`/operations/jobs/${j.id}`)} className="hover:bg-slate-50 cursor-pointer transition-colors">
                  <td className="px-4 py-3"><PriorityDot priority={j.priority} /></td>
                  <td className="px-4 py-3"><div className="font-mono-num text-[13px] font-semibold text-slate-800">{j.id}</div><div className="text-[11px] text-slate-400">{j.customer}</div></td>
                  <td className="px-4 py-3"><div className="text-slate-700">{j.mode}</div><div className="text-[11px] text-slate-400">{j.lane}</div></td>
                  <td className="px-4 py-3">
                    <BusinessStage stage={j.businessStage} />
                    {j.legacyRecord && <StatusPill className="ml-1.5" status="Legacy / Verification Required" data-testid={`legacy-badge-${j.id}`} />}
                  </td>
                  <td className="px-4 py-3"><StatusPill status={j.creditStatus} /></td>
                  <td className="px-4 py-3 text-right font-mono-num font-semibold text-slate-800">{money(j.estRevenue)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
